import React from "react";
import styles from "./stressDelPortafolioSuIpotesiStoriche.module.scss";
import commonStyles from "pages/assistant/components/artifacts/components/fineco-portfolio/finecoPortfolio.common.module.scss";
import StressDelPortafolioSuIpotesiLeftTable from "./StressDelPortafoglioSuIpotesiLeftTable";
import StressDelPortafolioSuIpotesiRightChart from "./StressDelPortafoglioSuIpotesiRightChart";
import { useTranslation } from "react-i18next";
// import FinecoTable from "./components/FinecoTable";
type Props = {
  data: any;
  mood: "positive" | "negative";
};
const StressDelPortafoglio: React.FC<Props> = ({ data, mood }) => {
  const { t } = useTranslation();
  let dataScenari = null;
  let title = "";
  let innerTitle = "";
  if (mood === "positive") {
    dataScenari =
      data.analisi_backtest.stress_del_portafoglio_eventi_scenari_positivi;
    title = t("portfolio.scenariPositiviTitle");
    innerTitle = t("portfolio.scenariPositiviInnerTitle");
  } else {
    dataScenari =
      data.analisi_backtest.stress_del_portafoglio_eventi_scenari_negativi;
    title = t("portfolio.scenariNegativiTitle");
    innerTitle = t("portfolio.scenariNegativiInnerTitle");
  }

  return (
    <>
      <h3 className={styles.sectionTitle}>{title}</h3>

      <div className={styles.portfolioDistribution}>
        <StressDelPortafolioSuIpotesiLeftTable
          dataItem={dataScenari}
          innerTitle={innerTitle}
        />
        <StressDelPortafolioSuIpotesiRightChart
          title={"ciao"}
          dataItem={dataScenari}
        />
      </div>
    </>
  );
};

export default StressDelPortafoglio;
